import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {AuthGuardGuard} from '@app/auth/guards/auth-guard.guard';
import {ExternalRedirectComponent} from "app/shared/components";

@NgModule({
  imports: [
    RouterModule.forRoot(
      [
        {
          path: 'my-profile',
          loadChildren: () =>
            import('src/app/profile/profile.module').then(
              (m) => m.ProfileModule
            ),
          canActivate: [AuthGuardGuard],
          data: {title: 'PROFILE.PROFILE_TITLE'},
        },
        {
          path: 'my-orders',
          loadChildren: () =>
            import('src/app/orders/orders.module').then((m) => m.OrdersModule),
          canActivate: [AuthGuardGuard],
          data: {title: 'ORDERS.ORDERS_TITLE'},
        },
        {
          path: 'notifications',
          loadChildren: () =>
            import('src/app/notifications/notifications.module').then(
              (m) => m.NotificationsModule
            ),
          canActivate: [AuthGuardGuard],
          data: {title: 'NOTIFICATIONS.NOTIFICATIONS'},
        },
        {
          path: 'meetings',
          loadChildren: () =>
            import('src/app/meetings/meetings.module').then(
              (m) => m.MeetingsModule
            ),
          canActivate: [AuthGuardGuard],
          data: {title: 'MEETINGS.MEETINGS_TITLE'},
        },
        {
          path: 'auth',
          loadChildren: () =>
            import('src/app/auth/auth.module').then((m) => m.AuthModule),
          canActivate: [AuthGuardGuard],
          data: {title: 'AUTH.AUTH'},
        },
        {
          path: '',
          component: ExternalRedirectComponent,
          pathMatch: 'full',
        },
        {
          path: '**',
          component: ExternalRedirectComponent,
          pathMatch: 'full',
        },
      ],
      {
        useHash: true,
      }
    ),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
